module.exports = __webpack_public_path__ + "static/media/goldenprizeth-tuna-soybeanchili-lid.0d86bd03.png";